/**
 * NotFoundPage — fallback for unmatched routes. Simple hero-style
 * layout with a "go back" button and a link home. Rendered by the
 * `path: '*'` wildcard route in App.tsx.
 */

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/Button';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="font-mono text-xs uppercase tracking-wider text-ink-subtle">
        404
      </p>
      <h1 className="mt-2 text-2xl font-semibold text-ink">
        {t('errors.not_found_title')}
      </h1>
      <p className="mt-2 max-w-md text-sm text-ink-muted">
        {t('errors.not_found_body')}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          {t('actions.back')}
        </Button>
        <Button onClick={() => navigate('/')}>{t('nav.vault')}</Button>
      </div>
    </div>
  );
}
